import { put } from 'redux-saga/effects'
import { mockupsError, mockupsSuccess } from '@core/redux/reducers/mockup/MockupSlice'

export function* handleMockup() {
    try {
        yield put(mockupsSuccess())
    } catch (error) {
        yield put(mockupsError({ error }))
    }
}